import Vue from 'vue';

import { COOKIE_DOMAIN } from '@/constants';

export function storeLocale(newLocale) {
  Vue.cookie.set('locale', newLocale, { domain: COOKIE_DOMAIN });
}

export function resetLocale() {
  Vue.cookie.delete('locale', { domain: COOKIE_DOMAIN });
}

export function retrieveLocale() {
  return Vue.cookie.get('locale');
}



// WEBPACK FOOTER //
// ./src/i18n/utils.js